import LastMinuteBackupModal from './LastMinuteBackupModal';

export default LastMinuteBackupModal;
